import { render } from "./SampleDownloadModal.vue?vue&type=template&id=d18f6de0"
import script from "./SampleDownloadModal.vue?vue&type=script&lang=js"
export * from "./SampleDownloadModal.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__